/* eslint-disable react/jsx-key */
import * as React from 'react';
import {
  IconInfrastructureChildPlayground16,
  IconInfrastructureCommercialObject16,
  IconInfrastructurePet16,
  IconInfrastructureFastService16,
  IconInfrastructureFitness16,
  IconInfrastructureKid16,
  IconInfrastructureOffice16,
  IconInfrastructureHospital16,
  IconInfrastructurePool16,
  IconInfrastructureRestaurant16,
  IconInfrastructureSchool16,
  IconInfrastructureSpa16,
  IconInfrastructureSportsground16,
  IconInfrastructureSupermarket16,
} from '@cian/ui-kit-design-tokens/icons';

import { EInfrastructureType } from '../../../../../../types/offer';

export const INFRASTRUCTURE_ICONS_MAP = new Map<EInfrastructureType, React.ReactNode>([
  [EInfrastructureType.Children, <IconInfrastructureChildPlayground16 />],
  [EInfrastructureType.Commerce, <IconInfrastructureCommercialObject16 />],
  [EInfrastructureType.Dogs, <IconInfrastructurePet16 />],
  [EInfrastructureType.Domestic, <IconInfrastructureFastService16 />],
  [EInfrastructureType.Fitness, <IconInfrastructureFitness16 />],
  [EInfrastructureType.Kindergarten, <IconInfrastructureKid16 />],
  [EInfrastructureType.Offices, <IconInfrastructureOffice16 />],
  [EInfrastructureType.Polyclinic, <IconInfrastructureHospital16 />],
  [EInfrastructureType.Pool, <IconInfrastructurePool16 />],
  [EInfrastructureType.Recreation, <IconInfrastructureChildPlayground16 />],
  [EInfrastructureType.Restaurant, <IconInfrastructureRestaurant16 />],
  [EInfrastructureType.School, <IconInfrastructureSchool16 />],
  [EInfrastructureType.Spa, <IconInfrastructureSpa16 />],
  [EInfrastructureType.Sport, <IconInfrastructureSportsground16 />],
  [EInfrastructureType.Supermarket, <IconInfrastructureSupermarket16 />],
]);
